module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "acknowledgment"
    }
  }, [_c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('em', [_vm._v("Prepare for the unknown by studying how others in the past have coped with the unforeseeable and the"), _c('br'), _vm._v(" unpredictable.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('strong', [_c('em', [_vm._v("―George S. Patton")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('em', [_vm._v("It is not often that nations learn from the past, even rarer that they draw the correct conclusions from it.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('strong', [_c('em', [_vm._v("―Henry Kissinger")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('em', [_vm._v("history is in constant rotation. do we learn from it, or is it evolving into a beast that knows how to hide within "), _c('br'), _vm._v("the shadows?")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('strong', [_c('em', [_vm._v("―Gregory S. Hudson")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('em', [_vm._v("A beast of knowledge filled with – what if – and – never again. a beast that manipulates the facts and disguises"), _c('br'), _vm._v(" them in newer, prettier packages of acceptance.")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('em', [_vm._v("wash, rinse, repeat.")])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('strong', [_c('em', [_vm._v("―Gregory S. Hudson")])])]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "center",
      "text-transform": "uppercase"
    }
  }, [_c('em', [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39322c3a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/Section0001.vue
// module id = 75
// module chunks = 0